import { useState, useCallback } from 'react'
import { Module } from '@estercare/ester-shared'

interface SelectedModule {
  title: string
  text: string
  image: string
}

export const useModuleModal = () => {
  const [selectedModule, setSelectedModule] = useState<SelectedModule | null>(null)

  const openModal = useCallback((module: Module, title: string, imageUrl: string) => {
    setSelectedModule({
      title,
      text: module.text,
      image: imageUrl,
    })
  }, [])

  const closeModal = useCallback(() => {
    setSelectedModule(null)
  }, [])

  return {
    selectedModule,
    openModal,
    closeModal,
    isOpen: Boolean(selectedModule),
  }
}
